<template>
  <v-tabs
    :id="getId"
    v-model="model"
    :class="['asc-tabs', vertical ? 'asc-vertical-tabs' : '']"
    :background-color="getTabColor"
    :hide-slider="vertical"
    :slider-color="getSliderColor"
    :vertical="vertical"
    @change="handleTabChange"
  >
    <slot></slot>
  </v-tabs>
</template>

<script>
import variables from '@/styles/_varsJs.scss'
import { AscTabPropsMixin } from '@/components/mixins'

export default {
  name: 'AscTab',

  mixins: [AscTabPropsMixin],

  data() {
    return {
      activeTab: this.value,
    }
  },

  computed: {
    getId() {
      return this.id || new Date().getTime()
    },
    getTabColor() {
      return this.secondary ? variables.gray100 : variables.primarywhite
    },
    getSliderColor() {
      return variables.accent400
    },
    model: {
      get() {
        return this.activeTab
      },
      set(newVal) {
        this.activeTab = newVal
        this.$emit('update:value', newVal)
        this.$emit('input', newVal)
      },
    },
  },

  watch: {
    value(newValue) {
      this.activeTab = newValue
    },
  },

  methods: {
    handleTabChange(whichTab) {
      this.$emit('tabChange', whichTab)
    },
  },
}
</script>

<style lang="scss">
.asc-tabs {
  .v-tabs-bar {
    height: auto !important;
  }

  .v-tabs-bar__content {
    max-height: 43px;
  }

  .v-slide-group__wrapper {
    border-bottom: solid 1px $gray-300;
    max-height: 43px;
  }

  &.asc-vertical-tabs {
    min-height: 397px;

    .v-slide-group__wrapper {
      background-color: $gray-200;
      border-bottom: none;
      max-height: none;
      min-height: 397px !important;

      .v-slide-group__content {
        display: flex;
        flex-flow: column;
        height: auto;
        max-height: none;
        min-height: 397px;
      }
    }
  }
}
</style>
